export default {"src":"https://fishbrain.com/_next/static/media/sturgeon.817e05ea.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};